'use strict';

import angular from 'angular';
import ngAnimate from 'angular-animate';
import ngCookies from 'angular-cookies';
import ngResource from 'angular-resource';
import ngSanitize from 'angular-sanitize';
import 'angular-socket-io';
import 'angular-drag-scroll';
import 'angular-paging';

import uiRouter from '@uirouter/angularjs';
import ngMessages from 'angular-messages';
import ngValidationMatch from 'angular-validation-match';

import ipCookie from 'angular-cookie';
import ngTokenAuth from 'ng-token-auth';
import ngMaterial from 'angular-material';
import duScroll from 'angular-scroll';

import moment from 'angular-moment'

import {
  appConfig
} from './app.config';

import account from './account';
import main from './main/main.component';
import './app.constant';
import '../components/logic/zip-search/api';
import util from '../components/logic/util/util.module';

import './app.css';
import './company/company.css';
import './company/create/company_create.css';
import './demand/detail/demand_detail.css';
import './demand_report/show/demand_report_show.css';
import './device_config/edit/device_config_edit.css';
import './device_error/device_error.css';
import './end_user/index/end_user_index.css';
import './end_user_confirm/end_user_confirm.css';
import './external_api_credential/external_api_credential.css';
import './home/home.css';
import './mail_template/mail_template.css';
import './main/main.css';
import './notify_list/show/notify_list_show.css';
import './oem/device_config/device_config.css';
import './oem/device_config/controller_create/controller_create.css';
import './oem/device_config/index/device_index.css';
import './oem/device_config/type_select/device_type_select.css';
import './retry/retry.css';
import './sa_group/sa_group.css';
import './price_report/price_report.css';
import './sa_reboot/sa_reboot.css';
import './oem/oem_user/oem_user.css';
import './end_user_reconfirm/end_user_reconfirm.css';
import './device-check-list/device-check-list.css';
import './home/home-device-list.css';
import './event_report/event_report.css';
import './oem/device_config/search-form/device_config_search_form.css';
import './demand/detail/simple-demand-display/simple-demand-display.css';
import './demand/detail/tablet-demand-display/tablet-demand-display.css';
import './statistics_report/show/statistics_show.css';

import '../../../node_modules/flatpickr/dist/flatpickr.min.css';

import Chart from '../components/directive/chart/chart.directive';
import AuthUtil from '../components/logic/auth_util/auth_util';
import LoginStateControl from '../components/logic/login_state_control/login_state_control';
import UniqueValidator from '../components/directive/unique_validator/unique_validator.directive';
import CsvUtil from '../components/logic/csv_util/csv.util';
import CompareWeatherLogic from '../components/logic/compare_weather/compare_weather.logic';
import ZipSearchLogic from '../components/logic/zip-search/zip-search.logic';

import RoleToStringFilter from '../components/filter/role_to_string/role_to_string.filter';
import GetErrorMessageFilter from '../components/filter/get_error_message/get_error_message.filter';
import DecimalFilter from '../components/filter/decimal-filter/decimal.filter';
import DayFilter from '../components/filter/day_filter/day.filter';
import NormalEventCount from '../components/filter/event-filter/normal-count.filter';
import ErrorEventCount from '../components/filter/event-filter/error-count.filter';
import CompanyListTitle from '../components/filter/company-list-title-filter/company-list-title.filter';
import WeatherName from '../components/filter/weather-name/weather-name.filter';

import CsvDownloarder from '../components/directive/csv_downloader/csv_downloader.directive';
import BulkDownloader from '../components/directive/csv_downloader/bulk_downloader.directive';
import DatePicker from '../components/directive/datepicker/datepicker.directive';
import DeadDurationSelector from '../components/directive/dead_duration_selector/dead_duration_selector.directive';
import DeviceConfigIndexItem from '../components/directive/device-index-item/device-index-item.directive';
import PaginationDirective from '../components/directive/pagination-directive/pagination.directive';
import SimpleDemandDisplay from './demand/detail/simple-demand-display/simple-demand-display.directive';
import TabletDemandDisplay from './demand/detail/tablet-demand-display/tablet-demand-display.directive';
import WeatherDirective from '../components/directive/weather/weather.directive';
import SaInfoDirective from '../components/directive/sa-info/sa-info.directive';

import SaConfigService from '../components/api/sa_config/sa_config.service';
import DistStockService from '../components/api/dist_stock/dist_stock.service';
import ActivePowerService from '../components/api/active_power/active_power.service';
import InstActivePowerService from '../components/api/inst_active_power/inst_active_power.service';
import DeviceErrorService from '../components/api/device_error/device_error.service';
import ExternalApiCredentialService from '../components/api/external_api_credential/external_api_credential.service'
import ServiceStockService from '../components/api/service_stock/service_stock.service';
import AnnounceService from '../components/api/announce/announce.service';
import MonthlyMaxDemandPowerService from '../components/api/monthly_max_demand_power/monthly_max_demand_power.service';
import MissingListService from '../components/api/missing_list/missing_list.service';
import RetryService from '../components/api/retry/retry.service';
import SaConfigNotifyListService from '../components/api/sa_config_notify_list/sa_config_notify_list.service';
import MailTestService from '../components/api/mail_test/mail_test.service';
import MailTextService from '../components/api/mail_text/mail_text.service';
import DemandPredictionLogic from '../components/logic/prediction/demand_prediction/demand_prediction_logic';
import MathUtil from '../components/logic/math_util/math_util';
import EventService from '../components/api/event/event.service';
import PredictedPowerService from '../components/api/predicted_power/predicted_power.service';
import DailyActivePowerService from '../components/api/daily_active_power/daily_active_power.service';
import MonthlyActivePowerService from '../components/api/monthly_active_power/monthly_active_power.service';
import SaGroupService from '../components/api/sa_group/sa_group.service';
import GroupActivePowerService from '../components/api/group_active_power/group_active_power.service';
import DailyGroupActivePowerService from '../components/api/daily_group_active_power/daily_group_active_power.service';
import MonthlyGroupACtivePowerService from '../components/api/monthly_group_active_power/monthly_group_active_power.service';
import GroupReportUtil from '../components/logic/group_report/group_report_util.service';
import SaRebootService from '../components/api/sa_reboot/sa_reboot.service';
import OemUserService from '../components/api/oem_user/oem_user.service';
import OemUserConfirmService from '../components/api/oem_user_confirm/oem_user_confirm.service';
import UserPasswordService from '../components/api/user_password/user_password.service';
import SaConfigSearchService from '../components/api/sa_config_search/sa_config_search.service';
import WeatherService from '../components/api/weather/weather.service';
import DailyWeatherService from '../components/api/daily_weather/daily_weather.service';
import PowerFormatter from '../components/logic/power-formatter/power-formatter.logic';
import CompareBookmarkService from '../components/api/compare_bookmark/compare_bookmark.service';
import GlobalEventService from '../components/api/global_event/global_event.service';

import home from './home/home.component';
import demand_index from './demand/index/demand_index.component';
import demand_detail from './demand/detail/demand_detail.component';
import demand_monitoring from './demand/monitoring/demand_monitoring.component';
import external_api_credential from './external_api_credential/external_api_credential.component';
import device_error from './device_error/device_error.component';
import device_index from './device_config/index/device_index.component';
import device_config_edit from './device_config/edit/device_config_edit.component';
import controller_config_edit from './device_config/controller_edit/controller_edit.component';
import retry from './retry/retry.component';
import demand_report_index from './demand_report/index/demand_report_index.component';
import demand_report_show from './demand_report/show/demand_report_show.component';
import daily_demand_report from './demand_report/daily/daily_demand_report.component';
import weekly_demand_report from './demand_report/weekly/weekly_demand_report.component';
import monthly_demand_report from './demand_report/monthly/monthly_demand_report.component';
import yearly_demand_report from './demand_report/yearly/yearly_demand_report.component';
import end_user_index from './end_user/index/end_user_index.component';
import end_user_create from './end_user/create/end_user_create.component';
import end_user_edit from './end_user/edit/end_user_edit.component';
import end_user_confirm from './end_user_confirm/end_user_confirm.component';
import notify_list_index from './notify_list/index/notify_list_index.component';
import notify_list_show from './notify_list/show/notify_list_show.component';
import demand_control_index from './demand_control/index/demand_control_index.component';
import demand_control_edit from './demand_control/edit/demand_control_edit.component';
import daily_active_report from './active_report/daily/daily_active_report.component';
import weekly_active_report from './active_report/weekly/weekly_active_report.component';
import monthly_active_report from './active_report/monthly/monthly_active_report.component';
import yearly_active_report from './active_report/yearly/yearly_active_report.component';
import demand_histogram from './demand_report/histogram/demand_histogram.component';
import sa_group_index from './sa_group/index/sa_group_index.component';
import sa_group_create from './sa_group/create/sa_group_create.component';
import sa_group_edit from './sa_group/edit/sa_group_edit.component';
import group_report_show from './group_report/show/group_report_show.component';
import daily_group_report from './group_report/daily/daily_group_report.component';
import weekly_group_report from './group_report/weekly/weekly_group_report.component';
import monthly_group_report from './group_report/monthly/monthly_group_report.component';
import yearly_group_report from './group_report/yearly/yearly_group_report.component';
import daily_price_report from './price_report/daily/daily_price_report.component';
import monthly_price_report from './price_report/monthly/monthly_price_report.component';
import end_user_reconfirm from './end_user_reconfirm/end_user_reconfirm.component';
import device_check_list from './device-check-list/device-check-list.component';
import event_report from './event_report/event_report.component';
import sa_reboot from './sa_reboot/end_user/sa_reboot.component';
import statistics_index from './statistics_report/index/statistics_index.component'
import statistics_show from './statistics_report/show/statistics_show.component';
import power_stat_table from './statistics_report/power-stat-table/power-stat-table.component';
import power_stat_graph_index from './statistics_report/power-stat-graph/index/power-stat-graph-index.component';
import power_stat_graph_event from './statistics_report/power-stat-graph/event/power-stat-graph-event.component';
import power_stat_graph_active from './statistics_report/power-stat-graph/active-power/power-stat-graph-active.component';
import power_stat_graph_demand from './statistics_report/power-stat-graph/demand-power/power-stat-graph-demand.component';
import weather_correlation_graph from './statistics_report/weather-stat-graph/weather-correlation-graph/weather-correlation-graph.component';
import temp_correlation_graph from './statistics_report/weather-stat-graph/temp-correlation-graph/temp-correlation-graph.component';
import compare_modal from './compare-modal/compare-modal.component';
import compare_graph from './compare-graph/show/compare-graph-show.component';
import compare_graph_daily_demand from './compare-graph/demand/daily/compare-graph-daily.component';
import compare_graph_weekly_demand from './compare-graph/demand/weekly/compare-graph-weekly.component';
import compare_graph_monthly_demand from './compare-graph/demand/monthly/compare-graph-monthly.component';
import compare_graph_yearly_demand from './compare-graph/demand/yearly/compare-graph-yearly.component';
import compare_graph_daily_active from './compare-graph/active/daily/compare-graph-daily-active.component';
import compare_graph_weekly_active from './compare-graph/active/weekly/compare-graph-weekly.component';
import compare_graph_monthly_active from './compare-graph/active/monthly/compare-graph-monthly-active.component';
import compare_graph_yearly_active from './compare-graph/active/yearly/compare-graph-yearly-active.component';
import compare_graph_index from './compare-graph/index/compare-graph-index.component';
import global_event from './global_event/global_event.component';

import oem_login from './account/oem_login/login.component';
import oem_main from './oem_main/oem_main.component';
import oem_home from './oem_home/oem_home.component';
import company_create from './company/create/company_create.component';
import company_index from './company/index/company_index.component';
import company_edit from './company/edit/company_edit.component';
import oem_device_config_create from './oem/device_config/create/device_config_create.component';
import oem_device_index from './oem/device_config/index/device_index.component';
import oem_device_config_edit from './oem/device_config/edit/device_config_edit.component';
import device_type_select from './oem/device_config/type_select/device_type_select.component';
import controller_device_create from './oem/device_config/controller_create/controller_create.component';
import controller_device_edit from './oem/device_config/controller_edit/controller_edit.component';
import oem_notify_list_show from './oem/notify_list/show/notify_list_show.component';
import mail_template from './mail_template/mail_template.component';
import oem_demand_control_index from './oem/demand_control/index/demand_control_index.component';
import oem_demand_control_edit from './oem/demand_control/edit/demand_control_edit.component';
import oem_sa_reboot from './sa_reboot/oem/sa_reboot.component';
import sa_reboot_item from './sa_reboot/sa_reboot_item/sa_reboot_item.component';
import oem_user_index from './oem/oem_user/index/oem_user_index.component';
import oem_user_create from './oem/oem_user/create/oem_user_create.component';
import oem_user_edit from './oem/oem_user/edit/oem_user_edit.component';
import oem_user_confirm from './oem_user_confirm/oem_user_confirm.component';
import oem_user_reconfirm from './oem/oem_user_reconfirm/oem_user_reconfirm.component';
import device_config_search_form from './oem/device_config/search-form/device_config_search_form.component';
import oem_global_event from './oem/global_event/global_event.component';

angular.module('leptonApp', [
  ngAnimate, ngCookies, ngResource, ngSanitize,
  ngMessages, ngValidationMatch,
  'btford.socket-io', uiRouter, ipCookie, ngTokenAuth, 'ng-drag-scroll', 'bw.paging',
  account, ngMaterial, moment, duScroll,
  main, Chart, SaConfigService, DistStockService, ActivePowerService, InstActivePowerService,
  DeviceErrorService, ServiceStockService, AnnounceService, ExternalApiCredentialService,
  SaConfigSearchService, CompareWeatherLogic, ZipSearchLogic,
  MonthlyMaxDemandPowerService, MissingListService, RetryService, AuthUtil, RoleToStringFilter,
  WeatherName,
  GetErrorMessageFilter, LoginStateControl, SaConfigNotifyListService, MailTestService, UniqueValidator,
  MailTextService, DemandPredictionLogic, MathUtil, EventService, PredictedPowerService, CsvDownloarder,
  DatePicker, DeadDurationSelector, DeviceConfigIndexItem, PaginationDirective, SimpleDemandDisplay, TabletDemandDisplay,
  WeatherDirective, SaInfoDirective,
  CsvUtil, SaGroupService, GroupActivePowerService, DailyGroupActivePowerService, MonthlyGroupACtivePowerService,
  GroupReportUtil, BulkDownloader, DecimalFilter, SaRebootService, OemUserService, DailyActivePowerService, MonthlyActivePowerService,
  OemUserConfirmService, UserPasswordService, DayFilter, NormalEventCount, ErrorEventCount,
  CompanyListTitle, WeatherService, DailyWeatherService, PowerFormatter, CompareBookmarkService,
  GlobalEventService,
  home, demand_index, demand_detail, demand_monitoring, demand_histogram,
  device_error, external_api_credential, device_index, device_config_edit, retry,
  daily_active_report, weekly_active_report, monthly_active_report, yearly_active_report,
  demand_report_index, demand_report_show, daily_demand_report, weekly_demand_report, monthly_demand_report,
  yearly_demand_report, end_user_index, end_user_create, company_edit, end_user_confirm, end_user_edit,
  notify_list_index, notify_list_show, controller_config_edit, demand_control_index, demand_control_edit,
  sa_group_index, sa_group_create, sa_group_edit, group_report_show, daily_group_report, weekly_group_report,
  monthly_group_report, yearly_group_report, daily_price_report, monthly_price_report,
  oem_login, oem_main, oem_home, company_create, company_index, oem_device_config_create, oem_device_index,
  oem_device_config_edit, oem_notify_list_show, mail_template, device_type_select, controller_device_create,
  controller_device_edit, oem_demand_control_index, oem_demand_control_edit, oem_sa_reboot, sa_reboot_item,
  oem_user_index, oem_user_create, oem_user_edit, oem_user_confirm, end_user_reconfirm,
  oem_user_reconfirm, device_check_list, event_report, device_config_search_form, sa_reboot,
  compare_graph_index, global_event,
  statistics_index, statistics_show, power_stat_table, power_stat_graph_index, power_stat_graph_event,
  power_stat_graph_active, power_stat_graph_demand, weather_correlation_graph, temp_correlation_graph,
  compare_modal, compare_graph, compare_graph_daily_demand, compare_graph_weekly_demand, compare_graph_monthly_demand,
  compare_graph_yearly_demand, compare_graph_daily_active, compare_graph_weekly_active, compare_graph_monthly_active,
  compare_graph_yearly_active, oem_global_event,
  'leptonApp.constants', util
])
  .config(appConfig)
  .run(($rootScope, $location, $state, $stateParams, $auth, $transitions, $trace, AuthUtil, LoginStateControl) => {
    'ngInject';

    $state.defaultErrorHandler(function () { /* do nothing */});

    $rootScope.$state = $state;
    $rootScope.$stateParams = $stateParams;

    $rootScope.$on('auth:login-success', (ev, user) => {
      AuthUtil.setUserInfo(user);
      LoginStateControl.goHome(user);
    });

    $rootScope.$on('auth:validation-success', (ev, user) => {
      AuthUtil.setUserInfo(user);
      LoginStateControl.rootToHome(user);
    });

    $rootScope.$on('auth:validation-error', (ev, user) => {
      LoginStateControl.goLogin();
    });

    $rootScope.$on('auth:logout-success', () => {
      AuthUtil.resetUserInfo();
      LoginStateControl.goLogin();
    });

    $transitions.onStart({}, trans => {
      const next = trans.to();
      const params = trans.params();

      if (next.name === 'login' ||
        next.name === 'oem_login' ||
        next.name === 'end_user_confirm' ||
        next.name === 'oem_user_confirm' ||
        next.name === 'end_user_reconfirm' ||
        next.name === 'oem_user_reconfirm'
      ) {
        return;
      }
      $auth.validateUser().then(user => {
        // ログインしているユーザーとアクセスしようとしている画面の種類が一致しているか検証
        if (next.name.match(/^oem_main\..+$/) && user.configName === 'default') {
          $state.go('main.home');
        } else if (!next.name.match(/^oem_main\..+$/) && user.configName === 'oemUser') {
          $state.go('oem_main.oem_home');
        }
      }).catch(() => {
        next.params = params;
        LoginStateControl.goLogin(next);
      });
    });

    $rootScope.isFullScreen = false;
    $rootScope.isSimpleDisplay = false;
    $rootScope.isTabletDisplay = false;
  });

angular.element(document)
  .ready(() => {
    angular.bootstrap(document, ['leptonApp'], {
      strictDi: true
    });
  });



// WEBPACK FOOTER //
// ./public/dev/app/app.js